// Active-reservation rows reach the "Select Room" dropdowns in two shapes: nested
// (room.room_number, guest.first_name) and flat (room_number, guest_name). Accept both so a
// staff login never ends up with an empty or crashing room list.
export const roomOptionLabel = (res) => {
  const room = res?.room?.room_number ?? res?.room_details?.room_number ?? res?.room_number ?? "N/A";
  const g = res?.guest || res?.guest_details || {};
  const name = [g.first_name, g.last_name].filter(Boolean).join(" ") || res?.guest_name || "";
  return `Room ${room}${name ? ` - ${name}` : ""}`;
};

export const roomOptions = (list) =>
  (Array.isArray(list) ? list : [])
    .filter(Boolean)
    .map((res) => ({ value: res.reservation_id ?? res.id, label: roomOptionLabel(res) }));

// Why the room list could not be loaded, in one line a person can read out or screenshot.
export const roomLoadError = (error, response) => {
  const status = error?.response?.status;
  const msg = error?.response?.data?.message || response?.message || error?.message || "Failed to fetch reservations";
  return status ? `${msg} (${status})` : msg;
};
